import type {
  IApiResponse,
  IResponse,
  OnboardingArtSerializer,
  OnboardingGenreSerializer,
  OnboardingInputUserPreferenceSerializer,
  UserViewedPopup,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";

export const onboardingApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getOnboardingGenres: build.query<OnboardingGenreSerializer[], void>({
      query: () => ({
        url: `/foundation/api/onboarding/genres`,
      }),
      transformResponse: (
        response: IApiResponse<OnboardingGenreSerializer[]>
      ) => {
        return response.payload.data;
      },
    }),
    getOnboardingArtsByGenres: build.query<
      OnboardingArtSerializer[],
      { genresIds: number[] }
    >({
      query: ({ genresIds }) => ({
        url: `/foundation/api/onboarding/arts`,
        params: { genres_ids: genresIds },
      }),
      transformResponse: (
        response: IApiResponse<OnboardingArtSerializer[]>
      ) => {
        return response.payload.data;
      },
    }),
    getUserSettingsPopup: build.query<UserViewedPopup, void>({
      query: () => ({
        url: `/foundation/api/users/me/settings/popup`,
      }),
      transformResponse: (response: IApiResponse<UserViewedPopup>) => {
        return response.payload.data;
      },
    }),
    saveViewedPopup: build.mutation<IApiResponse<IResponse>, void>({
      query: () => ({
        url: `/foundation/api/users/me/settings/popup`,
        method: "PUT",
        body: {
          viewed_popups: ["onboarding"],
        },
      }),
    }),
    saveUserPreferences: build.mutation<
      IApiResponse<IResponse>,
      { preferences: OnboardingInputUserPreferenceSerializer }
    >({
      query: ({ preferences }) => ({
        url: `/foundation/api/users/me/onboarding`,
        method: "PUT",
        body: preferences,
      }),
      onQueryStarted: async (params, { dispatch, queryFulfilled }) => {
        const patchResult = dispatch(
          onboardingApi.util.updateQueryData(
            "getUserSettingsPopup",
            undefined,
            draft => {
              draft.viewed_popups?.push("onboarding");
            }
          )
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});
